const Download = () => (
  <svg height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
    <title>Download</title>
    <path
      d={[
        'm15 17v4.9193752l2.5-2.000236.9209079-.7377863c.3534362-.2831559.8694961-.2261823 1.',
        '1526519.1272539l.2563495.3199765c.2658902.3318852.2123907.816478-.1194946 1.0823683l-.',
        '0857197.0699172-5 4c-.3652186.2921749-.8841714.2921749-1.24939 0l-4.99886832-4.0014147-.',
        '08550521-.0685025c-.33188525-.2658903-.3853848-.7504831-.11949457-1.0823683l.25634949-.',
        '3199765c.28315583-.3534362.79921567-.4104098 1.15265191-.1272539l.9202669.7385864 2.',
        '4992948 1.9994359v-4.9193752h-7.5c-1.93299662 0-3.5-1.5670034-3.5-3.5 0-1.4967435.',
        '93951243-2.7740522 2.2609722-3.2743609-.16770223-.37420353-.2609722-.78902913-.2609722-1.',
        '2256391 0-1.65685425 1.34314575-3 3-3 .49388634 0 .95989788.11934619 1.37076822.33077216.',
        '89303496-2.52324552 3.30004818-4.33077216 6.12923178-4.33077216 2.7039501 0 5.0222772 1.',
        '65104829 6.0018368 4.0000003 3.0367219.00099243 5.4981632 2.46304586 5.4981632 5.',
        '4999997 0 3.0375661-2.4624339 5.5-5.5 5.5zm0 0v-6.0736195c0-.2375993-.0371302-.3867484-.',
        '1068531-.5171188-.0697228-.1303704-.1720382-.2326858-.3024086-.3024086-.1303704-.',
        '0697229-.2795195-.1068531-.5171188-.1068531h-.147239c-.2375993 0-.3867484.0371302-.',
        '5171188.1068531-.1303704.0697228-.2326858.1720382-.3024086.3024086-.0697229.1303704-.',
        '1068531.2795195-.1068531.5171188v6.0736195z',
      ].join('')}
    />
  </svg>
);

export default Download;
